import { createRoute, AnyRoute, Outlet } from '@tanstack/react-router';
import ConfirmEmail from '@screens/auth/confirmEmail/ConfirmEmail';
import { RouteConfig } from './routeHelpers';
import { ForgotPasswordPage, LoginPage, ResetPasswordPage, SignupPage } from '@new/features/auth';
import SingleAgreement from '@screens/agreements/SingleAgreement';

const publicRouteConfigs: RouteConfig[] = [
  { path: 'login', component: LoginPage },
  { path: 'signup', component: SignupPage },
  { path: 'confirm-email', component: ConfirmEmail },
  { path: 'forgot-password', component: ForgotPasswordPage },
  { path: 'reset-password', component: ResetPasswordPage },
  { path: 'agreements/$type', component: SingleAgreement },
];

export const createPublicRoutes = (parent: AnyRoute) =>
  publicRouteConfigs.map(({ path, component }) =>
    createRoute({
      getParentRoute: () => parent,
      path,
      component,
    })
  );

export const createPublicRouteTree = (rootRoute: AnyRoute) => {
  const publicRoute = createRoute({
    getParentRoute: () => rootRoute,
    id: 'public',
    component: () => <Outlet />,
  });

  const children = createPublicRoutes(publicRoute);
  publicRoute.addChildren(children);

  return publicRoute;
};
